import { render } from "./Play.vue?vue&type=template&id=367d24e6&scoped=true"
import script from "./Play.vue?vue&type=script&lang=js"
export * from "./Play.vue?vue&type=script&lang=js"

import "./Play.vue?vue&type=style&index=0&id=367d24e6&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-367d24e6"]])

export default __exports__